module.exports = "<svg viewBox=\"0 0 20 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.4 21.82c-.82 0-1.4-.63-1.4-1.5V1.48C0 .62.58 0 1.37 0c.28 0 .56.08.83.24l17 9.73c.5.3.8.76.8 1.27 0 .52-.32.98-.84 1.26L2.2 21.6c-.27.15-.54.22-.8.22zm.42-19.7v17.62l15.9-8.53L1.8 2.1z\" fill=\"#FFF\" stroke=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/icons/play-icon.svg
// module id = Rwzd
// module chunks = 89